import { render, staticRenderFns } from "./ExporErret.vue?vue&type=template&id=0154b922&scoped=true&"
import script from "./ExporErret.vue?vue&type=script&lang=js&"
export * from "./ExporErret.vue?vue&type=script&lang=js&"
import style0 from "./ExporErret.vue?vue&type=style&index=0&id=0154b922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154b922",
  null
  
)

export default component.exports